export default __webpack_public_path__ + "static/media/Vectors3.36941ad7.svg";